export enum countries {
    INDIA = "IN",
    NEPAL = "NP",
    SRILANKA="LK",
}